// This is the config file for enemies and disasters.

export const dangers: DangersSetup = {
    anteater: {
        killChance: 1,
        movingSpeed: 1,
        searchDistance: 30,
        size: 10,
        wanderDistance: 50,
    },
    antWarrior: {
        killChance: 0.25,
        movingSpeed: 3,
        searchDistance: 3,
        size: 1.3,
        wanderDistance: 1,
    },
    antWorker: {
        carryCapacity: 15,
        movingSpeed: 2,
        searchDistance: 5,
        retargetChance: 0.8,
        wanderDistance: 2,
    },
    lawnmower: {
        killChance: 1,
        movingSpeed: 1,
        searchDistance: 20,
        size: 10,
        wanderDistance: 50,
    },
    magnifier: {
        killChance: 1,
        movingSpeed: 6,
        searchDistance: 30,
        size: 10,
        wanderDistance: 50,
    },
    spider: {
        killChance: 1,
        movingSpeed: 7,
        searchDistance: 8,
        size: 3,
    },
};